angular.module 'app'
.controller 'SingleArticleController', ($scope, $http, $state, $sce, $stateParams, $ionicPopup, config, activeUser) ->
  $scope.ui =
    baseUrl: config.api.baseUrl
    homepage: activeUser.homepage
    title: ''
    userInfo: activeUser.user
    column: {}
    article: {}
    content_html: null

  do findColumn = ->
    $http.get "#{config.api.baseUrl}/cumpus/programa/#{$stateParams.column_id}", {}
    .then (res) ->
      $scope.ui.column = res.data
      $scope.ui.title = $scope.ui.column.programa_name
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "系統出錯！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )

  do findArticle = ->
    $http.get "#{config.api.baseUrl}/cumpus/programa/list",
      params:
        is_content: true
        programa_id: $stateParams.column_id
        group_id: activeUser.group_id
    .then (res) ->
      if res.data.data.length > 0
        $scope.ui.article = res.data.data[0]
        $scope.ui.article.created_at = moment($scope.ui.article.created_at).format 'YYYY-MM-DD'
        $scope.ui.content_html = $sce.trustAsHtml $scope.ui.article.data.content
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "系統出錯！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )